import React, { useEffect, useRef, useState } from "react";
import MainComponent from "../MainComponent";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import keys from "../../utils/helpInfoKeys.json";

import "./XLStrategyPlan.css";
import CommentSection from "../../utils/CommentSection.js";
import Login from "../Login.js";
import {
  getXLStrategyPlanDetails,
  postXLStrategyPlanDetails,
} from "../../store/actions/index.js";
import SideNavHelpInfo from "../../utils/SideNavHelpInfo.js";
import { motion } from "motion/react";
import QuillEditor from "../../utils/QuillEditor.js";

function XLStrategyPlan() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleClick = () => {
    navigate("/executionplan");
  };
  const handleBack = () => {
    navigate("/dashboard");
  };
  const selectedHelpInfoSidebar = useSelector(
    (state) => state.selectedHelpInfoSidebar
  );
  const [formData, setFormData] = useState({
    opportunity_description: "",
    value_proposition: "",
    opportunity_value: "",
    customer_needs: "",
    target_customer_segments: "",
    key_players: "",
    substitutes: "",
    revenue_potential: "",
    monetisation_model_and_pricing: "",
    use_cases: "",
    distribution: "",
    key_risks_and_mitigation: "",
    operational_model: "",
    key_enablers_and_investment: "",
  });
  const [prevData, setPrevData] = useState("");
  const fetchgetXLStrategyPlanData = useSelector(
    (state) => state.fetchgetXLStrategyPlanData
  );
  useEffect(() => {
    if (localStorage.getItem("bi_id") && localStorage.getItem("product_id")) {
      dispatch(
        getXLStrategyPlanDetails(
          localStorage.getItem("bi_id"),
          localStorage.getItem("product_id")
        )
      );
    }
  }, []);
  useEffect(() => {
    if (fetchgetXLStrategyPlanData) {
      if (fetchgetXLStrategyPlanData?.data.length > 0) {
        console.log("fetchgetXLStrategyPlanData", fetchgetXLStrategyPlanData);
        setFormData(fetchgetXLStrategyPlanData.data[0]);
        setPrevData(fetchgetXLStrategyPlanData.data[0]);
      }
    }
  }, [fetchgetXLStrategyPlanData]);

  const typingTimeoutRef = useRef(null);

  const handleChange = (e) => {
    const { name, value } = e.target;
    const updatedFormData = {
      ...formData,
      [name]: value,
    };
    setFormData(updatedFormData);
    if (typingTimeoutRef.current) {
      clearTimeout(typingTimeoutRef.current);
    }
    typingTimeoutRef.current = setTimeout(() => {
      if (JSON.stringify(prevData) !== JSON.stringify(formData)) {
        dispatch(
          postXLStrategyPlanDetails(
            localStorage.getItem("bi_id"),
            localStorage.getItem("product_id"),
            updatedFormData
          )
        );
      }
    }, 2000);
  };

  const content = (
    <motion.div
      initial={{ y: "100%" }}
      animate={{ y: 0 }}
      transition={{ duration: 0.8, ease: "easeInOut" }}
    >
      <form className="strategyplan-form-layout">
        <div className="sp-dimension sp-dim-blue">
          <div className="sp-dim-header">
            <span className="sp-dim-title">Ambition</span>
          </div>
          <div className="sp-dim-body">
            <div className="sp-dim-col">
              <TextComponent
                label="Opportunity Description/ Market Need"
                name="opportunity_description"
                value={formData.opportunity_description}
                handleChange={handleChange}
              />
            </div>
            <div className="sp-dim-col">
              <TextComponent
                label="Value Proposition"
                name="value_proposition"
                value={formData.value_proposition}
                handleChange={handleChange}
              />
            </div>
            <div className="sp-dim-col sp-dim-narrow">
              <div className="sp-field">
                <div className="sp-field-label">
                  Opportunity Value
                </div>
                <textarea
                  className="sp-field-textarea"
                  name="opportunity_value"
                  value={formData.opportunity_value}
                  onChange={handleChange}
                />
              </div>
            </div>
          </div>
        </div>
        <div className="sp-dimension sp-dim-teal">
          <div className="sp-dim-header">
            <span className="sp-dim-title">Customer and Segments</span>
          </div>
          <div className="sp-dim-body">
            <div className="sp-dim-col">
              <TextComponent
                label="Customer Needs"
                name="customer_needs"
                value={formData.customer_needs}
                handleChange={handleChange}
              />
              <TextComponent
                label="Key Players"
                name="key_players"
                value={formData.key_players}
                handleChange={handleChange}
              />
            </div>
            <div className="sp-dim-col">
              <TextComponent
                label="Target Customer Segments"
                name="target_customer_segments"
                value={formData.target_customer_segments}
                handleChange={handleChange}
              />
              <TextComponent
                label="Substitutes"
                name="substitutes"
                value={formData.substitutes}
                handleChange={handleChange}
              />
            </div>
            <div className="sp-dim-col sp-dim-narrow">
              <div className="sp-field">
                <div className="sp-field-label">
                  Revenue Potential
                </div>
                <textarea
                  className="sp-field-textarea"
                  name="revenue_potential"
                  value={formData.revenue_potential}
                  onChange={handleChange}
                />
              </div>
            </div>
          </div>
        </div>
        <div className="sp-dimension sp-dim-purple">
          <div className="sp-dim-header">
            <span className="sp-dim-title">GTM and Execution</span>
          </div>
          <div className="sp-dim-body">
            <div className="sp-dim-col">
              <TextComponent
                label="Monetisation Model and Pricing"
                name="monetisation_model_and_pricing"
                value={formData.monetisation_model_and_pricing}
                handleChange={handleChange}
              />
              <TextComponent
                label="Distribution / Channel / Mix"
                name="distribution"
                value={formData.distribution}
                handleChange={handleChange}
              />
              <TextComponent
                label="Operational Model"
                name="operational_model"
                value={formData.operational_model}
                handleChange={handleChange}
              />
            </div>
            <div className="sp-dim-col">
              <TextComponent
                label=" Use Cases"
                name="use_cases"
                value={formData.use_cases}
                handleChange={handleChange}
              />
              <TextComponent
                label="Key Risks and Mitigation"
                name="key_risks_and_mitigation"
                value={formData.key_risks_and_mitigation}
                handleChange={handleChange}
              />
              <TextComponent
                label="Key Enablers and Investment"
                name="key_enablers_and_investment"
                value={formData.key_enablers_and_investment}
                handleChange={handleChange}
              />
            </div>
          </div>
        </div>
      </form>
      <div>{selectedHelpInfoSidebar && <SideNavHelpInfo />}</div>
    </motion.div>
  );
  if (!localStorage.getItem("authenticated")) {
    return (
      <div>
        <Login />
      </div>
    );
  } else {
    return (
      <>
        <MainComponent
          maincontent={content}
          // showTemplate={true}
          showSelector={true}
          showProducts={true}
          showButtons={true}
          handleNext={handleClick}
          handleBackButton={handleBack}
          breadcrumbParent={"GTM Execution"}
          breadcrumbChild={"XL Strategy Plan"}
          documentName={"XL Strategy Plan"}
          helpKey={keys["XL Strategy Plan"].Name}
          image={"question"}
        />
      </>
    );
  }
}

export default XLStrategyPlan;

export const TextComponent = ({ label, value, name, handleChange }) => {
  return (
    <div className="sp-field">
      <div className="sp-field-label">
        {label}
      </div>
      <div className="sp-field-editor">
        <QuillEditor
          value={value}
          onChange={(html) =>
            handleChange({ target: { name: name, value: html } })
          }
        />
      </div>
    </div>
  );
};
